import React, { Component } from 'react';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';

import RoutesUnAuth from '../RoutesUnAuth';

class RoutecontainerUnAuth extends React.Component {
    render() {
        return (
            <main style={{ marginTop: '1rem' }}>
                <RoutesUnAuth />
            </main>
        )
    }
}
export default withRouter(RoutecontainerUnAuth)